import React, { useEffect, useState } from "react";

export default function SplashScreen() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setTimeout(() => setVisible(false), 1000);
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center transition-opacity duration-700
        ${visible ? "opacity-100 z-50" : "opacity-0 pointer-events-none"}
        bg-white
      `}
    >
      <img
        src="/fulllogo_transparent_nobuffer.png"
        alt="Souqi Logo"
        className="w-40 animate-pulse"
      />
    </div>
  );
}

